import type { CMSChipLinkDTO } from "~/CMSComponents/dto";
import CMSChipLinkPopup from "./CMSChipLinkPopup";
import CMSChipLinkStandard from "./CMSChipLinkStandard";
import type { ChipVariant } from "~/common/m3/Chip/Chip";

export interface CMSChipLinkProps extends Omit<CMSChipLinkDTO, "type"> {
  className?: string;
  variant?: ChipVariant;
}

export const CMSChipLink = ({ chip, iconUrl, className, variant }: CMSChipLinkProps) => {
  const url = chip.navigationEntry.linkComponent.url;
  const isBulkEntry = url.includes("/bulkEntry");

  if (isBulkEntry) {
    return <CMSChipLinkPopup chip={chip} iconUrl={iconUrl} className={className} variant={variant} />;
  }

  return <CMSChipLinkStandard chip={chip} iconUrl={iconUrl} className={className} variant={variant} />;
};
